//Back to Top
const BttBtn = document.querySelector('.back-to-top');
const winHeight = window.innerHeight;
document.addEventListener("scroll", (event) => {
    const scrollPos = window.scrollY;
    if(scrollPos > winHeight) {
        if(!BttBtn.classList.contains('active')) {
            BttBtn.classList.add('active')
        }
    } else {
        if(BttBtn.classList.contains('active')) {
            BttBtn.classList.remove('active')
        }
    }
})
BttBtn.addEventListener('click', (e) => {
    e.preventDefault();
    window.scrollTo({top: 0, behavior: 'smooth'});
})

$('.header__icon--menu').click(function(){
  $('.menu-drawer-container').toggleClass('opening')
  $('.menu-drawer__detail').removeClass('submenu');
  $('.menu-drawer__menu li').removeClass('submenu');
})
$('.menu-drawer__detail>.menu-drawer__menu-item').click(function () {
  $(this).closest('.menu-drawer__detail').toggleClass('submenu');
});
$('.menu-drawer__inner-submenu .menu-drawer__menu-item').click(function () {
  $(this).closest('.menu-drawer__menu li').toggleClass('submenu');
});

$('.products-wrapper-slider').slick({
  dots: false,
  arrows:true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true,
          arrows:false,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.5,
        slidesToScroll: 1,
        dots: true,
          arrows:false,
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

    $('.products-wrapper-slider').on('afterChange', function (event, slick, currentSlide) {
        // Remove aria-hidden and tabindex from all slides
        $('.products-wrapper-slider .slick-slide').attr('aria-hidden', 'true').attr('tabindex', '-1');

        // Add them only to non-visible slides
        /*slick.$slides.each(function (index, slide) {
            if ($(slide).is('.slick-active')) {
                $(slide).attr('aria-hidden', 'false').attr('tabindex', '0');
            }
        });*/
    });
$('.products-wrapper-slider').trigger('afterChange');


var dialog = document.querySelector('[role="dialog"]');
var firstFocusableElement = dialog.querySelector('.first-focusable-element');
var lastFocusableElement = dialog.querySelector('.last-focusable-element');

dialog.addEventListener('keydown', function(e) {
  if(e.target == firstFocusableElement && e.key == 'Tab' && e.shiftKey) {
    e.preventDefault();
    lastFocusableElement.focus();
  } else if(e.target == lastFocusableElement && e.key == 'Tab' && !e.shiftKey) {
    e.preventDefault();
    firstFocusableElement.focus();
  }
});
